"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PAGINATION_STORAGE_KEY = exports.DEFAULT_PAGINATION = exports.DEFAULT_PAGE_SIZE = exports.DEFAULT_PAGE = exports.DEFAULT_ERROR_MESSAGE = void 0;
exports.getTableRows = getTableRows;
exports.saveSessionPagination = saveSessionPagination;

var _preact = require("preact");

var _Checkbox = _interopRequireDefault(require("@insided/shared/uikit/Checkbox"));

var _ActionsTableCell = _interopRequireDefault(require("./ActionsTableCell"));

var DEFAULT_PAGE = 1;
exports.DEFAULT_PAGE = DEFAULT_PAGE;
var DEFAULT_PAGE_SIZE = 25;
exports.DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
var DEFAULT_PAGINATION = {
  pagination: {
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE
  }
};
exports.DEFAULT_PAGINATION = DEFAULT_PAGINATION;
var PAGINATION_STORAGE_KEY = 'tagsPagination';
exports.PAGINATION_STORAGE_KEY = PAGINATION_STORAGE_KEY;
var DEFAULT_ERROR_MESSAGE = 'Something went wrong, please try again.';
exports.DEFAULT_ERROR_MESSAGE = DEFAULT_ERROR_MESSAGE;

function saveSessionPagination(page, pageSize) {
  var item = window.sessionStorage.getItem(PAGINATION_STORAGE_KEY);
  var storage = item ? JSON.parse(item) : null;
  storage.pagination = {
    page: page,
    pageSize: pageSize
  };
  window.sessionStorage.setItem(PAGINATION_STORAGE_KEY, JSON.stringify(storage));
}

function getTableRows(tags, selectAllTags, areAllTagsSelected, selectTag, onEditTag, onRemoveTag) {
  return tags.map(function (tag) {
    return [{
      header: (0, _preact.h)(_Checkbox.default, {
        label: "",
        onUpdate: function onUpdate(value) {
          selectAllTags(value);
        },
        qaClasses: "qa-select-all",
        checked: areAllTagsSelected
      }),
      accessor: 'tag-selector',
      cell: (0, _preact.h)(_Checkbox.default, {
        label: "",
        onUpdate: function onUpdate(value) {
          selectTag(tag, value);
        },
        qaClasses: "qa-select-all",
        checked: Boolean(tag.selected)
      })
    }, {
      header: 'Public tags',
      accessor: 'tag-name',
      cell: (0, _preact.h)("span", {
        className: "public-tag-".concat(tag.id, " qa-public-tag-").concat(tag.id)
      }, tag.name)
    }, {
      header: 'Topics tagged',
      accessor: 'usage',
      cell: (0, _preact.h)("span", {
        className: "qa-public-tag-".concat(tag.id, "-usage")
      }, tag.count)
    }, {
      header: 'Actions',
      accessor: 'actions',
      cell: (0, _preact.h)(_ActionsTableCell.default, {
        tag: tag,
        onEditTag: onEditTag,
        onDeleteTag: onRemoveTag
      })
    }];
  });
}